import { DecimalField } from '@ff-it/form';
import { Box, Stack, Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { ReactElement, ReactNode } from 'react';

const weeks1 = Array.from(Array(18).keys()).map((_, idx) => ({ value: idx + 1, label: `Week ${idx + 1}` }));
const weeks2 = Array.from(Array(18).keys()).map((_, idx) => ({ value: idx + 19, label: `Week ${idx + 19}` }));
const weeks3 = Array.from(Array(16).keys()).map((_, idx) => ({ value: idx + 37, label: `Week ${idx + 37}` }));

type WeekTableProps = {
  weeks: { value: number; label: string }[];
  name: string;
  label: ReactNode;
};

function WeekTable({ weeks, name, label }: WeekTableProps) {
  return (
    <Table size="xs" textSize="sm" bordered>
      <Thead>
        <Tr>
          <Th>Week</Th>
          <Th style={{ width: '120px' }} className="text-right">
            {label}
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {weeks.map(({ value, label }) => (
          <Tr key={value}>
            <Td>{label}</Td>
            <Td>
              <DecimalField precision={2} name={`${name}._${value}`} size="sm" className="mb-0 text-right" />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}

type WeekFactorsProps = {
  name: string;
  label: ReactNode;
};

export function WeekFactors({ name, label }: WeekFactorsProps): ReactElement {
  return (
    <Stack direction="horizontal">
      <Box flexGrow={1}>
        <WeekTable weeks={weeks1} name={name} label={label} />
      </Box>
      <Box flexGrow={1}>
        <WeekTable weeks={weeks2} name={name} label={label} />
      </Box>
      <Box flexGrow={1}>
        <WeekTable weeks={weeks3} name={name} label={label} />
      </Box>
    </Stack>
  );
}
